import { useConfig } from 'shared/config/ConfigContext';
import useFetch from 'shared/hooks/useFetch';
import { formatISODate } from 'shared/util/datetime-fns';
import { queryString } from 'shared/util/query';
import type { PriceCleaningChoice, PrivateItemPrice } from '@/domain';

const url = (
    apiExternalUrl: string,
    itemId: string,
    fromDate: string,
    toDate: string,
    guests = 1,
    cleaningChoice?: PriceCleaningChoice | null,
) =>
    `${apiExternalUrl}/calendar/price-private${queryString({
        itemId: itemId,
        fromDate: fromDate,
        toDate: toDate,
        guests: guests,
        cleaningChoice: cleaningChoice,
    })}`;

export const usePrivateItemPrice = (
    itemId: string,
    fromDate: Date,
    toDate: Date,
    guests = 1,
    cleaningChoice: PriceCleaningChoice | null = null,
) => {
    const { apiExternalUrl } = useConfig();

    const { data: privateItemPrice, ...rest } = useFetch<PrivateItemPrice>({
        url: url(apiExternalUrl, itemId, formatISODate(fromDate), formatISODate(toDate), guests, cleaningChoice),
        options: { keepPreviousData: true },
        isEnabled: !!itemId && !!fromDate && !!toDate, //Avoid making invalid calls when data is not yet fetched by other hook
    });

    return { privateItemPrice, ...rest };
};
